// extracted by mini-css-extract-plugin
export default {"proLabel":"GlobalCopilotMenu-module__proLabel--dtXSW"};